<template>
<!--  <div id="nav">-->
<!--	<Header/>-->
<!--  </div>-->
  <slot>
    <router-view/>


  </slot>

</template>
<script>
	import Header from "@/ZH-CN/Header";
    let ws = null;
    let websockets = null;
    export default {
      name: "App",
      data() {
        return {
          a: '',
        }
      },
      components: {
        // Header
      },
      methods: {
        webSocket() {
          if ("WebSocket" in window) {
            console.log("您的浏览器支持WebSocket");
            ws = new WebSocket("ws://localhost:8081/websocket"); //创建WebSocket连接

            ws.send("连上了哥们123456");
            ws.onmessage = function (event) {
              if (typeof event.data === String) {
                console.log("Received data string");

              }

              if (event.data instanceof ArrayBuffer) {
                var buffer = event.data;
                console.log("Received arraybuffer");
              }
              this.a.start();


              // ws.close();
            };


            //...
          } else {
            console.log("您的浏览器不支持WebSocket");
          }
        },

      },

    }
</script>
<style>
  html,body{
    margin: 0;
    height: 100%;
  }
</style>
